module.exports = __webpack_public_path__ + "img/sz.b385b900.png";